import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { MaterialIcon, MaterialIconProps } from '@makyoapp/makyo-tw-ui'

import { ColumnIconMap } from '@/shared/icons/column'

interface ColumnTypeIconProps extends Omit<MaterialIconProps, 'icon'> {
  type: ColumnTypes
}

/**
 * New column type icon using material symbols
 */
export function ColumnTypeIcon({ type, ...props }: ColumnTypeIconProps) {
  return <MaterialIcon size={16} {...props} icon={ColumnIconMap[type]} />
}
